<template>
  <div class="box online_bg">
    <div class="wrap w1200">
      <!--左侧分类-->
      <div class="col_1 w246 online_left">
        <router-link v-for="item in menu" v-bind:key="item.id" :to="item.component" active-class="focus" @click="currentClass = item.className">{{item.name}}</router-link>
      </div>
      <!--/左侧分类-->
      <!--右侧列表-->
      <router-view></router-view>
    </div>
    <!--/右侧列表-->
    <div class="clear"></div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    components: { },
    props: ['menu'],
    data () {
      return {
        currentClass: 'task_kc_list'
      }
    },
    created () {
    },
    mounted () {
    },
    computed: {
      ...mapState('auth', ['user', 'token'])
    },
    methods: {
      ...mapActions('auth', {
        logout: 'logout'
      }),
      toLogout () {
        this.logout(this.user.id)
      },
      toReg () {
        this.$router.push('/byl/orgreg')
      },
      toRecord () {
        this.$router.push('/org')
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/modules/task/index.vue